import React from 'react';
import {
  FaCloud,
  FaLaptopCode,
  FaServer,
  FaShieldAlt,
  FaNetworkWired,
  FaDatabase,
  FaCogs,
  FaHeadset
} from 'react-icons/fa';

const Services: React.FC = () => {
  const services = [
    {
      icon: <FaCloud className="text-5xl text-blue-600" />,
      title: 'Cloud Computing',
      description: 'Scalable cloud solutions including Azure, AWS, and hybrid cloud implementations for seamless business operations.',
    },
    {
      icon: <FaLaptopCode className="text-5xl text-blue-600" />,
      title: 'Software Solutions',
      description: 'Custom software development and enterprise solutions tailored to meet your unique business requirements.',
    },
    {
      icon: <FaServer className="text-5xl text-blue-600" />,
      title: 'IT Infrastructure',
      description: 'Complete IT infrastructure setup, maintenance, and management for optimal performance and reliability.',
    },
    {
      icon: <FaShieldAlt className="text-5xl text-blue-600" />,
      title: 'Cyber Security',
      description: 'Comprehensive security solutions to protect your business from evolving cyber threats and data breaches.',
    },
    {
      icon: <FaNetworkWired className="text-5xl text-blue-600" />,
      title: 'Network Solutions',
      description: 'Enterprise networking solutions including LAN, WAN, VPN setup and network security implementation.',
    },
    {
      icon: <FaDatabase className="text-5xl text-blue-600" />,
      title: 'Data Management',
      description: 'Database design, management, and analytics solutions for better business intelligence and decisions.',
    },
    {
      icon: <FaCogs className="text-5xl text-blue-600" />,
      title: 'IT Consulting',
      description: 'Expert IT consulting services to help you make informed technology decisions and digital transformation.',
    },
    {
      icon: <FaHeadset className="text-5xl text-blue-600" />,
      title: '24/7 Support',
      description: 'Round-the-clock technical support and maintenance services to ensure your systems run smoothly.',
    },
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold text-lg">What We Offer</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-4">
            Our Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We provide comprehensive IT solutions designed to transform your business
            and help you stay ahead in the competitive digital landscape.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group"
            >
              <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
              <a
                href="#contact"
                className="inline-block mt-6 text-blue-600 font-semibold hover:text-orange-500 transition-colors duration-300"
              >
                Learn More →
              </a>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Ready to Transform Your Business?
          </h3>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
            Let us help you leverage technology to achieve your business goals.
            Contact us today for a free consultation.
          </p>
          <a
            href="#contact"
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
          >
            Get Started Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
